import * as React from 'react';
import { Label } from '@cian/ui-kit';
import * as styles from './PromoSnippetLabels.css';

interface IPromoSnippetLabelsProps {
  isSalesLeader: boolean;
}

export function PromoSnippetLabels({ isSalesLeader }: IPromoSnippetLabelsProps) {
  return (
    <>
      {isSalesLeader && (
        <span className={styles.label} data-testid="salesLeader">
          <Label background="gray10_100" color="black_100">
            Лидер продаж
          </Label>
        </span>
      )}
    </>
  );
}
